export const FARMING_MIN_LEVEL = 40;
export const FARM_EMPTY_SLOT_IMAGE = 'image/farm/bos.png';
export const FARM_TILLED_SLOT_IMAGE = 'image/farm/bellenmis.png';
export const FARMING_SHOVEL_BASE_ITEM_ID = 21;
